import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-composite-score-widget',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './composite-score-widget.component.html',
  styleUrl: './composite-score-widget.component.scss'
})
export class CompositeScoreWidgetComponent implements OnInit {
  @Input() compositeScore: any = null;
  @Input() title: string = 'Composite Score';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  constructor() { }

  ngOnInit(): void {
  }

  // Helper method to get score color based on value (scale is always 0-100)
  getScoreColor(score: number): string {
    if (score >= 80) return '#4caf50'; // Green
    if (score >= 60) return '#ff9800'; // Orange
    if (score >= 40) return '#ff5722'; // Red-Orange
    return '#f44336'; // Red
  }

  // Helper method to get score label based on value (scale is always 0-100)
  getScoreLabel(score: number): string {
    if (score >= 90) return 'Excellent';
    if (score >= 80) return 'Very Good';
    if (score >= 70) return 'Good';
    if (score >= 60) return 'Fair';
    return 'Poor';
  }

  // Get the score value from different possible data structures
  getScoreValue(): number {
    if (typeof this.compositeScore === 'number') {
      return Math.round(this.compositeScore);
    }
    if (this.compositeScore?.value) {
      return Math.round(this.compositeScore.value);
    }
    return 0;
  }

  // Get the score label from different possible data structures
  getScoreLabelValue(): string {
    if (this.compositeScore?.label) {
      return this.compositeScore.label;
    }
    return this.getScoreLabel(this.getScoreValue());
  }

  // Get the brand name from different possible data structures
  getBrandName(): string {
    if (this.compositeScore?.brand) {
      return this.compositeScore.brand;
    }
    return this.title;
  }
}
